export const RANKING_STRINGS = {
  EARNERS: 'Top Earners',
  HAPPIEST: 'Happiest People',
  EMPTY: 'You have no statistics for the past rounds.',
} as const;
